"use strict";

var getValueOfKeyMatching = require('../getValueOfKeyMatching');

function parseWrappers(params, size) {
  var quantity = 0;

  if (params.product_type.match(/floral/i)) {
    quantity = parseInt(getValueOfKeyMatching(params, /invitations/), 10);
  } else if (getValueOfKeyMatching(params, /wrappers/).match(/Printed Belly Band/)) {
    quantity = parseInt(getValueOfKeyMatching(params, /lp_invitations/), 10);
  } else {
    quantity = parseInt(getValueOfKeyMatching(params, /wrappers/), 10);
  }

  var possible_wrapper_color = getValueOfKeyMatching(params, /color-grid-pers/);
  var wrapper_color = '';

  if (params['floral-belly-band-pers']) {
    wrapper_color = params['floral-belly-band-pers'];
  } else if (possible_wrapper_color) {
    if (possible_wrapper_color.split(', ').length === 1) {
      wrapper_color = possible_wrapper_color.split(', ')[0];
    }
  }

  if (quantity > 0) {
    var primaryKey = 'wrappers';

    if (size === 'thick') {
      primaryKey = 'thickWrappers';
    }

    this[primaryKey].add({
      quantity: quantity,
      wrapper_color: wrapper_color
    });
  }
}

module.exports = parseWrappers; // this.mediumWrappers.add({ quantity, wrapper_color });